import Icon from 'components/Icon/Icon';
import {
  CurrentItemsLabel,
  RowCenter,
  TotalItemsLabel,
} from './Pagination.styled';
import { COLORS, marginXs } from 'assets/styled';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

interface IPaginatedProps {
  page: number;
  perPage: number;
  total: number;
  setPage: (page: number) => void;
}

export const Pagination = ({
  page,
  perPage,
  total,
  setPage,
}: IPaginatedProps) => {
  const getSecondPaginationNumber = () => {
    if (page * perPage > total) {
      return total;
    } else {
      return page * perPage;
    }
  };
  const hasNextPage = perPage * page < total;

  const handleLoadPage = (newPage: number) => {
    if (newPage === 0) {
      return;
    }
    setPage(newPage);
  };

  return (
    <RowCenter>
      <Icon
        svg={CaretLeft}
        color={page === 1 ? COLORS.GRAY_100 : COLORS.GREEN}
        size={18}
        weight="bold"
        onClick={() => handleLoadPage(page - 1)}
        marginRight={marginXs}
        disabled={page === 1}
      />
      <CurrentItemsLabel>
        {(page - 1) * perPage + 1} - {getSecondPaginationNumber()}
      </CurrentItemsLabel>
      &nbsp; <TotalItemsLabel>of {total}</TotalItemsLabel>
      <Icon
        svg={CaretRight}
        color={hasNextPage ? COLORS.GREEN : COLORS.GRAY_100}
        disabled={!hasNextPage}
        size={18}
        weight="bold"
        marginLeft={marginXs}
        onClick={() => hasNextPage && handleLoadPage(page + 1)}
      />
    </RowCenter>
  );
};

export default Pagination;
